<template lang="pug">
.section-visao
  .content
    h2.titulo
      span.barra
      span
        | A 
        span.destaque Visão
        |  por Trás da Inovação
    p.texto
      | Na busca por soluções inovadoras no cenário de tecnologia da informação, surge uma ideia visionária, fruto da experiência profunda e do insight de 
      span.nome C. Yamakawa
      | . Reconhecendo uma lacuna crítica no mercado de TI, onde a comunicação e a identificação de habilidades técnicas se apresentam como barreiras significativas, Carlos visualizou uma oportunidade única. Inspirado por sua jornada profissional, ele idealizou uma plataforma que aborda diretamente este desafio.
    .linha-verde
</template>

<script>
export default {
  name: 'VisaoInovacao'
}
</script>

<style lang="scss" scoped>
.section-visao {
  background: linear-gradient(45deg, transparent, rgba(109, 215, 8, 0.2), transparent);
  border: 1px solid rgba(109, 215, 8, 0.3);
  border-radius: 8px;
  padding: 48px;
  color: #ccc;
  max-width: 1024px;
  width: 100%;
  box-sizing: border-box;
  margin: 80px 0;
  backdrop-filter: blur(5px);

  .content {
    margin: 0 auto;
    text-align: left;

    .titulo {
      font-size: 36px;
      font-weight: bold;
      color: #fff;
      margin: 0 0 32px 0;
      text-align: center;

      .barra {
        display: inline-block;
        width: 4px;
        height: 48px;
        background: #6dd708;
        margin-right: 16px;
      }

      .destaque {
        color: #6dd708;
      }
    }

    .texto {
      font-size: 20px;
      line-height: 1.3;
      color: #969992;
      text-align: justify;

      .nome {
        color: #6dd708;
        font-weight: bold;
      }
    }

    .linha-verde {
      margin-top: 1.5rem;
      width: 80px;
      height: 4px;
      background: linear-gradient(to right, transparent, #6dd708, transparent);
      border-radius: 2px;
      margin: 0 auto;
    }
  }

  @media (max-width: 768px) {
    padding: 32px 24px;
    margin: 60px 16px;

    .content {
      .titulo {
        font-size: 30px;

        .barra {
          width: 3px;
          height: 36px;
          margin-right: 12px;
        }
      }

      .texto {
        font-size: 18px;
        line-height: 1.4;
      }
    }
  }

  @media (max-width: 540px) {
    margin: 40px 0;
    
    .content {
      max-width: 262px;
      box-sizing: border-box;
      .titulo {
        display: flex;
        flex-direction: column;
        align-items: center;

        .barra {
          width: 3px;
          height: 32px;
          margin-right: 10px;
        }
      }

      .texto {
        line-height: 1.6;
      }

      .linha-verde {
        width: 60px;
        height: 3px;
        margin-top: 1rem;
      }
    }
  }

  @media (max-width: 360px) {
    padding: 20px 16px;
    margin: 32px 8px;

    .content {
      .titulo {
        font-size: 20px;

        .barra {
          width: 2px;
          height: 28px;
          margin-right: 8px;
        }
      }

      .texto {
        font-size: 14px;
        line-height: 1.6;
      }

      .linha-verde {
        width: 50px;
        height: 3px;
      }
    }
  }
}
</style>
